<div>
    <ul class="root-list" tabindex="0" *ngIf="menuGroups?.length" [appAutoFocus]="true">
        <li
            class="root-item"
            *ngFor="let rootList of menuGroups; trackBy: trackById; let itemIndex = index"
            aria-level="1"
        >
            <app-link *ngIf="!rootList.hasChildren && rootList.link as link" [link]="link">
                <span class="root-link">
                    {{ link.name || rootList.name }}
                </span>
            </app-link>
            <ng-container
                *ngIf="
                    rootList.hasChildren &&
                    rootList.children &&
                    rootList.children.length &&
                    rootList.children[0].children
                "
            >
                <button class="root-link" (click)="setActiveRootList(rootList)" aria-haspopup="true">
                    {{ rootList.name }}
                    <app-svg-icon iconName="chevron_right"></app-svg-icon>
                </button>
            </ng-container>
        </li>
    </ul>
</div>
